export default "__VITE_ASSET__DOMi8n8W__"